<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
            fill="currentColor"
        />
        <path
            d="M6.5 5H5.5V9H6.5V5Z"
            fill="currentColor"
        />
        <path
            d="M6 4C6.41421 4 6.75 3.66421 6.75 3.25C6.75 2.83579 6.41421 2.5 6 2.5C5.58579 2.5 5.25 2.83579 5.25 3.25C5.25 3.66421 5.58579 4 6 4Z"
            fill="currentColor"
        />
    </svg>
</template>
